import JobFilterStatuses from "./jobQuestionFilter";
import KeyValue from "./keyValue";

export default interface Question {
  id: number;
  questionText: string;
  answerType: KeyValue;
  required: boolean;
  sensitiveData: boolean;
  multipleChoice: boolean;
  freeSolo: boolean;
  choices: KeyValue[];
  filterSelectedJobType?: KeyValue;
  filterSelectedJobStatuses: JobFilterStatuses[];
  order: number;
  customStaticOptions: boolean;
  sortByAscending: boolean;
}

export enum AnswerTypes {
  Section = 1,
  Text,
  Phone,
  Checkbox,
  Multiline,
  Dates,
  DateTime,
  MultipleChoice,
  Site,
  Category,
  Source,
  Method,
  WeeklyTask,
  Status,
  Title,
  Date,
  Time,
  DateRange,
  Confidential,
  Job,
}
